import React from 'react';
import * as locCon from '../LocalConstants';
import CustomButton from '../elements/CustomButton';

import { useState } from 'react';
import CustomText from '../elements/CustomText';
import { RefContextLanguage } from '../providers/LanguageProvider';
import { sleep } from '../community-hats-js-library/utils/generalFunctions';
import CustomSpin from '../elements/CustomSpin';

export function PlacementPicture({ positionPlacementObject }) {
  const [showImage, setShowImage] = useState(false);
  const [loadImage, setLoadImage] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const getImage = async () => {
    setLoadImage(true);
    setImageLoaded(false);
    await sleep(1000);
    setLoadImage(false);
    setShowImage(true);
  };

  const i18n = RefContextLanguage();

  return (
    <div className="verticalSection">
      <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{i18n.t('picturePlacement')}</CustomText>

      {/* Preload image invisibly while spinner is active */}
      {loadImage && 'url' in positionPlacementObject && (
        <img src={positionPlacementObject.url} alt="" onLoad={() => setImageLoaded(true)} style={{ display: 'none' }} />
      )}

      {!showImage ? (
        <div style={{ minHeight: '10vh', marginTop: '2vh' }}>{loadImage && <CustomSpin />}</div>
      ) : (
        <div>
          {'url' in positionPlacementObject ? (
            <div style={{ marginTop: '2vh', marginBottom: '2vh', marginLeft: '1vh', marginRight: '1vh' }}>
              {!imageLoaded && <CustomSpin />}
              {/* eslint-disable-next-line */}
              <img
                src={positionPlacementObject.url}
                alt={'Picture Placement'}
                style={{ maxWidth: '100%', maxHeight: '100%', display: imageLoaded ? 'block' : 'none' }}
                onLoad={() => setImageLoaded(true)}
              />
            </div>
          ) : (
            <CustomText type={locCon.DANGER_TEXT}>{i18n.t('noImageAvailable')}</CustomText>
          )}
        </div>
      )}

      <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => getImage(true)}>
        Show Image
      </CustomButton>
    </div>
  );
}

export default PlacementPicture;
